import { PropsWithChildren, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import SeoProjectContext from '@/contexts/seoProjectContext';
import { useSeoFetch } from '@/hooks/useSeoFetch';
import seoProjectsService from '@/services/seoProjects';
import { FetchApiIds } from '@/types';
import { SeoProject } from '@/types/api/seo';
import SEOxProjectComponent from './SEOxProject.component';

type Props = PropsWithChildren;

const SEOxProject = (props: Props): JSX.Element => {
  const { projectId = '' } = useParams();
  const [breadcrumbDetail, setBreadcrumbDetailState] = useState<string | null>(null);

  const setBreadcrumbDetail = useCallback((label: string | null) => {
    setBreadcrumbDetailState(label);
  }, []);

  const {
    data: project,
    refetch,
    isLoading,
  } = useSeoFetch<SeoProject>(
    [FetchApiIds.SEO_PROJECT_BY_ID, projectId],
    () => seoProjectsService.getById(projectId)
  );

  return (
    <SeoProjectContext.Provider
      value={{
        project: project as SeoProject | undefined,
        refetchProject: refetch,
        isLoadingProject: isLoading,
        breadcrumbDetail,
        setBreadcrumbDetail,
      }}
    >
      <SEOxProjectComponent project={project as SeoProject | undefined} {...props} />
    </SeoProjectContext.Provider>
  );
};

export default SEOxProject;
